import { TEXTOS } from '../../../lib/glossario'
import type { IndicadorNaTela } from '../../../types/chamado'
import { calculoAplicado, faixaAlcancada, nivelApurado } from './linhasDoTrp'
import { TRP } from './textoDoTrp'

/**
 * O quadro dos níveis mínimos de serviço, com a coluna "Nível" corrigida.
 *
 * **O modelo assinado tem um defeito nesta coluna, e ele é de preenchimento de gabarito.** No TRP
 * nº 01 as quatro células trazem "Até 1 dia útil de atraso", "Entre 1 e 3 dias úteis", "Superior a
 * 3 dias úteis" e "Superior a 5 dias úteis" — uma escada crescente única, que é o nível de UM
 * indicador copiado em quatro linhas. E não serve para nenhum deles: o ICA é razão de 0 a 1, o IAE
 * é percentual de aceite, e o TIS mede em horas, não em dias. Aqui a célula traz o índice apurado,
 * que é o número que decidiu o desconto. Ver `nivelApurado`.
 *
 * **Indicador sem apuração ocupa a linha, com o motivo.** Omiti-lo faria o quadro afirmar que o
 * ANEXO VIII tem quatro indicadores, quando tem seis — e foi assim que IAD e IIE sumiram do
 * documento assinado.
 *
 * @param props os seis indicadores da competência
 * @returns o quadro
 */
export function QuadroDeIndicadores({ indicadores }: { indicadores: IndicadorNaTela[] }) {
  const q = TRP.quadroApuracao
  return (
    <table className="trp-tabela">
      <caption className="sr-only">{TRP.fundamentoDosIndicadores}</caption>
      <thead>
        <tr>
          <th scope="col">{q.indicador}</th>
          <th scope="col">{q.calculo}</th>
          <th scope="col">{q.nivel}</th>
          <th scope="col">{q.faixa}</th>
          <th scope="col">{q.evidencia}</th>
        </tr>
      </thead>
      <tbody>
        {indicadores.map((indicador, posicao) => (
          <tr key={indicador.codigo}>
            <th scope="row">
              {LETRAS[posicao] ?? ''}) {indicador.codigo} — {indicador.rotulo}
            </th>
            <td>{calculoAplicado(indicador)}</td>
            <td>{nivelApurado(indicador)}</td>
            <td>{faixaAlcancada(indicador) || naoApurado(indicador)}</td>
            <td>{indicador.apurado ? q.evidenciaPadrao : naoApurado(indicador)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

/** As letras com que o TRP numera os indicadores no quadro: "A) ICA", "B) IAP"... */
const LETRAS = ['A', 'B', 'C', 'D', 'E', 'F']

/** O que ocupa a célula quando o indicador não pôde ser apurado. Nunca zero, nunca vazio. */
function naoApurado(indicador: IndicadorNaTela): string {
  return indicador.apurado ? '' : TEXTOS.fiscalizacao.naoApurado
}
